import { CnCOrderResponse, RFZOTherapyResponse } from "./api";

// Base interface for items that can appear in ReceivedColumn
export interface BaseReceivableItem {
  id: number;
  created: string;
  firstName: string;
  secondName: string;
  status: string;
  userLBO?: string;
}

// Enhanced types with discriminator for type-safe handling
export interface CnCOrderReceivableItem extends CnCOrderResponse {
  itemType: "ORDER";
}

export interface RFZOTherapyReceivableItem extends RFZOTherapyResponse {
  itemType: "RFZO_REQUEST";
}

// Union type for type-safe handling
export type ReceivableItem = CnCOrderReceivableItem | RFZOTherapyReceivableItem;

// Type guards for runtime type checking
export const isCnCOrder = (
  item: ReceivableItem
): item is CnCOrderReceivableItem => {
  return item.itemType === "ORDER";
};

export const isRFZORequest = (
  item: ReceivableItem
): item is RFZOTherapyReceivableItem => {
  return item.itemType === "RFZO_REQUEST";
};

// Utility functions for type transformation
export const mapToCnCOrderReceivable = (
  order: CnCOrderResponse
): CnCOrderReceivableItem => ({
  ...order,
  itemType: "ORDER" as const,
});

export const mapToRFZOReceivable = (
  rfzo: RFZOTherapyResponse
): RFZOTherapyReceivableItem => ({
  ...rfzo,
  itemType: "RFZO_REQUEST" as const,
});
